<div [ngClass]="[isOpen ? 'shown' : '']" class="app-application-menu p-3" (click)="menuClick($event)">
    <ng-content></ng-content>
    <a class="app-application-menu-button d-inline-block d-xl-none" href="javascript:;" (click)="toggle()">
        <i class="ri-more-fill"></i>
    </a>
</div>